<template>
  <v-speed-dial
    v-model="fab"
    fixed
    top
    direction="bottom"
    transition="slide-y-reverse-transition"
    style="top: 90px"
  >
    <template v-slot:activator>
      <v-btn
        v-model="fab"
        color="success"
        dark
        fab
        large
      >
        <v-icon>apps</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
    </template>

    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          dark
          color="primary"
          v-on="on"
          :to="{ path: urlEdit }"
        >
          <v-icon>edit</v-icon>
        </v-btn>
      </template>
      <span>Editer le cv</span>
    </v-tooltip>
    
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          dark
          color="yellow darken-3"
          v-on="on"
          :to="{ path: urlModel }"
        >
          <v-icon>description</v-icon>
        </v-btn>
      </template>
      <span>Changer le modèle de cv</span>
    </v-tooltip>
    
    <CvPreviewNew
      :cvid="cvid"
      :displayAsFab="true"
    ></CvPreviewNew>

    <CvDownloadPDF
      :cvid="cvid"
      :displayAsFab="true"
    ></CvDownloadPDF>

  </v-speed-dial>
  
</template>

<script>
 
 import CvPreviewNew from './CvPreviewNew.vue';
 import CvDownloadPDF from './CvDownloadPDF.vue';

 export default {
   props: ['cvid'],
   components: {
     CvPreviewNew,
     CvDownloadPDF
   },
   data() {
     return {
       fab: false,
       urlModel: '/cv/' + this.cvid + '/cvmodels',
       urlEdit: '/cv/' + this.cvid + '/edit',
     }
   },
 }
</script>


